import { CircularProgress } from '@mui/material'
import React from 'react'

const CustomApiLoader = () => {
  return (
    <CircularProgress/>
  )
}

export default CustomApiLoader